import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import Icon from 'JS/components/Icon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileAppCallout',
  setup(__props) {


return { __sfc: true,BButton, Icon }
}

})